import {useEffect} from 'react';
interface ISelectLabTestsProps {
  isSuccess: boolean;
  lab?: ILabAddInfo;
  labTests?: Array<ILabTest>;
  setSelectableLabTests: (value: Array<ILabTest>) => void;
}
const useSelectLabTests = ({
  isSuccess,
  lab,
  labTests,
  setSelectableLabTests,
}: ISelectLabTestsProps) => {
  useEffect(() => {
    if (isSuccess)
      setSelectableLabTests(
        labTests?.map(item => {
          const isSelected = lab?.services_activity_field?.find(
            labitem => labitem.guid === item.guid,
          );
          return {
            ...item,
            selected: isSelected ? true : false,
          };
        }) || [],
      );
  }, [
    isSuccess,
    lab?.services_activity_field,
    labTests,
    setSelectableLabTests,
  ]);
};

export default useSelectLabTests;
